<template>
  <div id="app">
    <meta :name="domain" content="Resort, Hotel, Thermal, Villa, Halal, Islamisch, Islami, Türkei, Antalya"/>
    <title>Finden Sie jetzt ihre Traumhotel! "Halal", "Resort", "Hotel", "Thermal", "Villa"</title>

    <div class="div-dsgvo-app" v-if="this.dsgvo !== 'true'">
      <label class="label-dsgvo-app">
        Diese Website nutzt Cookies, um Ihnen die bestmögliche Funktionalität zu bieten. Durch die weitere Nutzung der
        Webseite stimmen Sie der Verwendung zu.
      </label>
      <v-btn class="btn-dsgvo vbtn-linear-gradient" @click="confirm">Zustimmen</v-btn>
      <v-btn text class="btn-dsgvo" @click="zuDSGVO">
        Unsere Datenschutzerklärung<br> finden Sie hier
      </v-btn>

    </div>

    <v-app
    >
      <div v-if="userinfo.kontakt">
        <Header
            :pLogo="logo"
            :tel="userinfo.kontakt.tel"
            :mobile="userinfo.kontakt.mobile"
            :lang="lang"
            :pDomain="domain"
        />
      </div>

      <div id="nav">

      </div>
      <router-view
          id="router-view"
          :kontakt="userinfo.kontakt"
          :lang="lang"
          :pLang="lang"
          :pLogo="logo"
          :pDomain="domain"
          :pRechtliches="rechtliches"
          :pCurrencyValues="currencyValues"
          :pCurrency="currency"
          :pSetting="settings"
          :pFavSearch="settingFavsearch"
      />

      <h1 style="display: none">{{domain}}</h1>
      <div v-if="domain==='holidaytimes.de'">
        <Footer3
            v-if="userinfo.kontakt"
            :kontakt="userinfo.kontakt"
            :pDomain="domain"
        />
      </div>

      <div v-if="domain==='efehotels.com'||domain==='ceeyuu.de'">
        <Footer2
            v-if="userinfo.kontakt"
            :kontakt="userinfo.kontakt"
            :pDomain="domain"
        />
      </div>

    </v-app>
  </div>

</template>

<script>
import Header from "./components/headerfooter/Header";
import Footer from "./components/headerfooter/Footer";
import Footer2 from "./components/headerfooter/Footer2";
import Footer3 from "./components/headerfooter/Footer3";
import CeeYuuFooter2 from "./components/headerfooter/CeeYuuFooter2";
import {getIDFromAdminUser, getLogo} from "./util/DBUtil";
import {getKontaktFromUserinfoByUserId, getRechtlichesByID} from "./util/userinfoDBUtil";
import {getdomain, getFacilitiesFromSettings, getFavSearchFromSettings} from "./util/settingsUtil";
import {getCurrencyKey, getCurrencyValues} from "@/util/currencyUtil";



export default {
  components: {
    Footer,
    Footer2,
    Footer3,
    Header,
    CeeYuuFooter2
  },
  data() {
    return {
      dsgvo: "",
      mode: "",
      logo: "",
      userinfo: "",
      lang: 'DE',


      halalHotels: "",
      settings: "",

      showSkeleton: true,


      domain: "",
      rechtliches: "",

      currencyValues: "",
      currency: "EUR",
      settingFavsearch: ""

    }
  },
  methods: {
    zuDSGVO() {
      this.$router.push({path: "privacy"});
      window.scrollTo(0, 0);
    },
    confirm() {
      this.$cookie.set('_confirm', 'true', 365);
      this.dsgvo = this.$cookie.get('_confirm');
    }
  },

  async created() {


    this.dsgvo = this.$cookie.get('_confirm');

    if (localStorage.getItem("lang")) {
      this.lang = localStorage.getItem("lang");
    } else {
      localStorage.setItem("lang", this.lang);
    }
    if (!localStorage.getItem("currency")) {
      localStorage.setItem("currency", "EUR");
    }

    let user = await getIDFromAdminUser();
    let logo = await getLogo(user._id);
    this.logo = process.env.VUE_APP_IMAGES + logo.logo.picture;
    this.userinfo = await getKontaktFromUserinfoByUserId(user._id);
    this.rechtliches = await getRechtlichesByID(user._id);

    this.domain = await getdomain();

    this.settings = await getFacilitiesFromSettings();


    if (localStorage.getItem("currency")) {
      this.currency = localStorage.getItem("currency");
    } else {
      localStorage.setItem("currency", this.currency);
    }
    let ckey = await getCurrencyKey();

    this.currencyValues = await getCurrencyValues(ckey.currencyKey);

    let favSearch = await getFavSearchFromSettings()
    this.settingFavsearch = favSearch[0].favorite_search;





  },
  mounted() {
    window.scrollTo(0, 0);
  }
}

</script>


<style>
@import './index.css';
@import 'css/StartALT.css';

</style>
